// Shared "active artifact" channel between a plugin app's right panel (which owns
// the open tabs) and its LEFT side chat (a separate component). The panel
// publishes the currently-focused artifact here; the side chat reads it when
// building its system context so the agent edits THAT artifact only. A plain
// module-level Solid signal — global + reactive, read from anywhere.

import { createSignal } from "solid-js"

export type ActiveArtifact = {
  pluginID: string
  directory: string
  path: string // plugin-relative path, e.g. "Canvas/q3.html"
  name: string
  content: string
}

const [activeArtifact, setActiveArtifact] = createSignal<ActiveArtifact | null>(null)

export { activeArtifact, setActiveArtifact }

/** Clear the active artifact iff it currently belongs to `pluginID` (panel unmount). */
export function clearActiveArtifact(pluginID: string) {
  setActiveArtifact((cur) => (cur?.pluginID === pluginID ? null : cur))
}
